import { ArrowUpRight } from "lucide-react";
import React, { useState, useEffect } from "react";
import CTAButton from "../Buttons/CTAButton/CTAButton";
import VerticalCarousel from "../ui/VerticleCarousel/VerticalCarousel";
import EventCarouselCard from "./EventCarouselCard";
import { fetchEvents, getStaredEventsArray } from "../../services/eventService";

const MessageSection = () => {
  const [staredEvents, setStaredEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStaredEvents = async () => {
      const data = await fetchEvents();
      if (data) {
        const stared = getStaredEventsArray(data);
        setStaredEvents(stared);
      }
      setLoading(false);
    };
    loadStaredEvents();
  }, []);

  // Prepare slides for vertical carousel
  const slides = staredEvents.map((event, index) => ({
    key: event.id || index,
    content: <EventCarouselCard event={event} />
  }));

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px] sm:gap-[30px] lg:gap-[40px] bg-Color-White text-Color-Black font-[Montserrat] px-4 sm:px-8 lg:px-numbers-100 py-6 sm:py-8 lg:py-numbers-48 mt-8 sm:mt-12 lg:mt-numbers-64">
      <div className="border-l-2 border-l-Color-Brand py-4 sm:py-8 lg:py-numbers-16 pl-4 sm:pl-6 lg:pl-numbers-32">
        <h1 className="text-xl sm:text-2xl lg:text-h2-desktop mb-2 sm:mb-3 lg:mb-4">Our Anniversary</h1>
        <span className="text-Color-Brand text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold font-['Montserrat'] underline">
        Stories
        </span>
        <p className="leading-tight mt-4 sm:mt-6 lg:mt-[40px] font-weight-medium text-sm sm:text-base lg:text-body-desktop">
          Discover where our passion for engineering education and
          groundbreaking research began, explore the vibrant communities of
          students, staff, and alumni who shaped us, and glimpse how we're set
          to engineer a brighter future for Sri Lanka and beyond.
        </p>
        <div className="mt-4 sm:mt-6 lg:mt-[40px]">
          <CTAButton text="EXPLORE EVENTS" url="/events" isRainbow={true} />
        </div>
      </div>
      
      {/* Vertical Carousel for Starred Events */}
      <div
        data-layer="Event Carousel Container"
        className="EventCarouselContainer self-stretch relative bg-transparent rounded-lg min-h-[350px] sm:min-h-[450px] md:min-h-[500px] lg:min-h-[600px] flex items-center justify-center my-28 mb-14 md:my-16 lg:my-0"
      >
        {loading ? (
          <div className="flex items-center justify-center h-full w-full opacity-50">
            {/* Skeleton Loader for Carousel Card */}
            <div className="w-[90vw] sm:w-[80vw] md:w-[70vw] lg:w-[600px] h-[54vw] sm:h-[48vw] md:h-[42vw] lg:h-[360px] max-w-[600px] max-h-[360px] bg-gradient-to-br from-gray-200 to-gray-300 animate-pulse">
              {/* Image Skeleton */}
              <div className="w-full h-[72%] bg-gradient-to-br from-gray-300 to-gray-400"></div>
              {/* Content Skeleton */}
              <div className="px-2 sm:px-3 md:px-4 py-2 sm:py-2.5 md:py-3 flex flex-col gap-2">
                {/* Title Lines */}
                <div className="h-3 sm:h-3.5 md:h-4 bg-gray-400 rounded w-3/4"></div>
                <div className="h-3 sm:h-3.5 md:h-4 bg-gray-400 rounded w-1/2"></div>
                {/* Button Skeleton */}
                <div className="h-5 sm:h-6 md:h-7 bg-gray-400 rounded w-24 sm:w-28 md:w-32 mt-auto"></div>
              </div>
            </div>
          </div>
        ) : staredEvents.length > 0 ? (
          <VerticalCarousel
            slides={slides}
            offsetRadius={2}
            showNavigation={false}
            showDots={false}
            animationConfig={{ tension: 120, friction: 14 }}
          />
        ) : (
          <div className="flex flex-col items-center justify-center h-full px-6">
            <div className="text-6xl mb-4">⭐</div>
            <h3 className="text-xl font-bold text-gray-700 mb-2 font-['Montserrat'] text-center">
              Featured Events Coming Soon
            </h3>
            <p className="text-gray-500 text-center font-['Montserrat']">
              Stay tuned for our highlighted anniversary events!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageSection;